import { useState } from 'react'
import { useOrgAuditEvents } from '@/lib/hooks'
import { formatDateTime } from '@/lib/format'

/** Collapsible audit trail of policy.settings.update events (#9). */
export function PolicyChangeHistory({ orgId }: { orgId: string }) {
  const [open, setOpen] = useState(false)
  const { data, loading } = useOrgAuditEvents(open ? orgId : '', 'policy.settings.update', 20)
  const events = open ? (data?.events ?? []) : []

  return (
    <div style={{ borderTop: '1px solid var(--border)', paddingTop: 10 }}>
      <button
        className="btn btn-ghost btn-sm"
        style={{ fontSize: '0.72rem' }}
        onClick={() => setOpen((v) => !v)}
      >
        {open ? '▾' : '▸'} Change history
      </button>
      {open && (
        <div style={{ marginTop: 8, display: 'grid', gap: 6 }}>
          {loading && <span className="spinner" />}
          {!loading && events.length === 0 && (
            <div style={{ fontSize: '0.72rem', color: 'var(--text3)' }}>No recorded changes.</div>
          )}
          {events.map((e) => (
            <div key={e.id} style={{ fontSize: '0.72rem', color: 'var(--text2)', fontFamily: 'var(--mono)' }}>
              {formatDateTime(e.created_at)} — {e.actor_email ?? 'unknown'}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

